<template>
  <div v-loading="loading">
    <QS-h3-title title="基础信息" />
    <QS-column-box :source="details" :column="3" :list="list" separator=":">
      <template v-slot:followList>
        <QS-common-table :data="details.followList" :columns="columns" :pagination="false" />
      </template>
      <template v-slot:carResource>
        <el-button v-if="details.carSourceTitle" type="text" @click="carResourceEvent" style="width: 100px">{{details.carSourceTitle}}</el-button>
        <span v-else>--</span>
      </template>
    </QS-column-box>
  </div>
</template>

<script>
import { businessManageDetail } from '@/api/carResource/index.js'

export default {
  data() {
    return {
      details: {
        followList: [],
        carSourceTitle: '',
        carSourceId: '',
      },
      columns: [
        {
          name: 'gmtCreate',
          columnProps: {
            label: '跟进时间',
            prop: 'gmtCreate',
            width: '160px',
          },
        },
        {
          name: 'createUserName',
          columnProps: {
            label: '跟进人',
            prop: 'createUserName',
            width: '120px',
          },
        },
        {
          name: 'messageStateName',
          columnProps: {
            label: '商机状态',
            prop: 'messageStateName',
            width: '120px',
          },
        },
        {
          name: 'followRecord',
          columnProps: {
            label: '跟进内容',
            prop: 'followRecord',
            width: '400px',
          },
        },
      ],
      list: [
        {
          key: 'id',
          name: '商机ID',
        },
        {
          key: 'brandName',
          name: '品牌',
        },
        {
          key: 'seriesName',
          name: '车系',
        },
        {
          key: 'modelName',
          name: '车型',
        },
        {
          key: 'leaseTypeName',
          name: '租赁类型',
        },
        {
          key: 'transactionCityName',
          name: '交车城市',
        },
        {
          key: 'enterpriseName',
          name: '企业名称',
        },
        {
          key: 'contacts',
          name: '联系人',
        },
        {
          key: 'mobile',
          name: '联系人电话',
        },
        {
          key: 'leasePeriods',
          name: '租赁期数',
        },
        {
          key: 'leaseNumber',
          name: '租赁数量',
        },
        {
          key: 'stateName',
          name: '商机状态',
        },
        {
          key: 'gmtCreate',
          name: '创建时间',
        },
        {
          key: 'carResource',
          name: '车源信息',
        },
        {
          key: 'followList',
          name: '跟进记录',
          alone: true,
        },
      ],
      loading: false,
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    carResourceEvent() {
      this.$router.push({
        path: '/purchaseProvide/infoManage/detail',
        query: { carResourceId: this.details.carSourceId, leaseType: this.details.leaseType },
      })
    },
    getDetail() {
      const { id } = this.$route.query
      this.loading = true
      businessManageDetail({ id }).then((res) => {
        const { code, data } = res || {}
        if (code === 1) {
          this.details = data
        }
      }).finally(() => {
        this.loading = false
      })
    },
  },
}
</script>
<style lang='less' scoped>
.basic-list {
  margin-top: 0;
}
</style>
